var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
var OutsourceRecycleService = /** @class */ (function () {
    function OutsourceRecycleService() {
    }
    /**
     * 委外回收案件查询
     */
    OutsourceRecycleService.prototype.caseOutRecoveryList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourceRecycleManageController.caseOutRecoveryList,
            data: {
                outBatch: data.outBatch,
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                mobileNo: data.mobileNo,
                idCard: data.idCard,
                localAddress: data.localAddress,
                currentCollector: data.currentCollector,
                overduePeriod: data.overduePeriod,
                turnSource: data.turnSource,
                followupBack: data.followupBack,
                productCategory: data.productCategory,
                productName: data.productName,
                followInTimeStart: FilterService.dateRanageFormat(data.followInTime).start,
                followInTimeEnd: FilterService.dateRanageFormat(data.followInTime).end,
                area: data.area,
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                overdueAmountStart: data.outAmount ? data.outAmount.min : '',
                overdueAmountEnd: data.outAmount ? data.outAmount.max : '',
                labelName: data.labelName,
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 申请流转
     */
    OutsourceRecycleService.prototype.applyCirculation = function (data) {
        return this.netService.send({
            server: domainService.outsourceRecycleManageController.applyCirculation,
            data: data
        });
    };
    /**
     * 移入委外待分配
     */
    OutsourceRecycleService.prototype.caseMoveAllocation = function (data) {
        return this.netService.send({
            server: domainService.outsourceRecycleManageController.caseMoveAllocation,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceRecycleService.prototype, "netService", void 0);
    return OutsourceRecycleService;
}());
export { OutsourceRecycleService };
